// @flow
import type {
  AuthState,
  ResetPasswordOperation,
} from 'hfty-auth/types'

import type {
  Action,
} from 'fc-flow-types/redux'

// Redux
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// Selectors, Action Creators, Operator
import { resetPassword } from 'fc-auth/src/actions'
import { resetPasswordOperation$, resetPasswordOperator } from 'hfty-auth'

// Operator
type Props = {
  resetPasswordOperation: ?ResetPasswordOperation,
}

type Actions = {
  actions: {
    resetPassword: typeof login,
  }
}

function onChange (operation: ResetPasswordOperation): Action<ResetPasswordOperation> {
  const action = resetPasswordOperator().actionCreators.updateOperation(operation)

  return {
    ...action,
    error: null,
    meta: null,
  }
}

const mapStateToProps = function<S: { auth: AuthState }> (state: S): Props {
  return {
    operation: resetPasswordOperation$(state),
  }
}

const mapDispatchToProps = function (dispatch: Dispatch<*>): Actions {
  return {
    actions: bindActionCreators({
      onSubmit: resetPassword,
      onChange,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
